function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { GeometryCollection, LinearRing, LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon } from 'ol/geom';
import OL3Parser from 'jsts/org/locationtech/jts/io/OL3Parser';
import TopologyValidationError from 'jsts/org/locationtech/jts/operation/valid/TopologyValidationError';
import IsValidOp_MultipleErrors from './IsValidOp_MultipleErrors';

class ValidateGeometryError {
  constructor(errorType, errorMessage) {
    this.errorType = errorType;
    this.errorMessage = errorMessage;
    this.errorType = errorType;
    this.errorMessage = errorMessage;
  }

}

class ValidateGeometryResult {
  constructor(geometry) {
    this.geometry = geometry;

    _defineProperty(this, "isValid", void 0);

    _defineProperty(this, "errors", new Array(0));

    this.geometry = geometry;
    this.isValid = true;
  }

  withError(errorType, errorMessage) {
    this.isValid = false;
    this.errors.push(new ValidateGeometryError(errorType, errorMessage));
  }

  get errorType() {
    var _this$errors$;

    return (_this$errors$ = this.errors[0]) === null || _this$errors$ === void 0 ? void 0 : _this$errors$.errorType;
  }

  get errorMessage() {
    var _this$errors$2;

    return (_this$errors$2 = this.errors[0]) === null || _this$errors$2 === void 0 ? void 0 : _this$errors$2.errorMessage;
  }

}

function validateGeometry(geometry) {
  var parser = new OL3Parser();
  parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon, GeometryCollection);
  var result = new ValidateGeometryResult();

  if (geometry) {
    try {
      var jstsGeometry = parser.read(geometry);
      var validator = new IsValidOp_MultipleErrors(jstsGeometry);
      var validationErrors = validator.getValidationError();

      if (validationErrors.length) {
        validationErrors.forEach(validationError => result.withError(validationError.getErrorType(), validationError.getMessage()));
      }
    } catch (error) {
      result.withError(TopologyValidationError.ERROR, error.message);
    }
  }

  return result;
}

export { validateGeometry, ValidateGeometryResult, ValidateGeometryError };